import { Grid } from '@/components';
import { Stack, Typography } from '@mui/material';
import {
  CustomBlue,
  CustomContainer,
  CustomGreen,
  CustomRed,
  CustomYellow,
} from './Filter.components';

export const Card = () => {
  return (
    <Stack gap={3} mt={2}>
      <Typography fontSize={16}>Total Ticket Transactions Overview</Typography>
      <Grid columns={4} gap={20}>
        <CustomContainer color="#28C76F">
          <CustomGreen>
            <svg
              width="27"
              height="24"
              viewBox="0 0 27 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 3.5H24C25.3785 3.5 26.5 4.62145 26.5 6V9C26.5 9.09726 26.4133 9.25357 26.1992 9.3584L26.0996 9.39941C25.0232 9.77205 24.25 10.7968 24.25 12C24.25 13.2031 25.0233 14.2269 26.0996 14.5996V14.6006C26.3867 14.7011 26.5 14.8889 26.5 15V18C26.5 19.3785 25.3785 20.5 24 20.5H3C1.62145 20.5 0.5 19.3785 0.5 18V15C0.5 14.8889 0.613339 14.7011 0.900391 14.6006L0.899414 14.5996C1.97617 14.2271 2.75 13.2034 2.75 12C2.75 10.7965 1.97633 9.7718 0.899414 9.39941H0.900391C0.613339 9.29893 0.5 9.11113 0.5 9V6C0.5 4.62145 1.62145 3.5 3 3.5Z"
                stroke="white"
              />
              <path
                d="M9 12L12 15L18 9"
                stroke="white"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </CustomGreen>
          <Typography fontSize={24} fontWeight={600}>
            3,500
          </Typography>
          <Typography fontSize={16} fontWeight={500}>
            Total Redeemed <br />
            Tickets
          </Typography>
        </CustomContainer>
        <CustomContainer color="#FDD70E">
          <CustomYellow>
            <svg
              width="28"
              height="24"
              viewBox="0 0 28 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 3.5H24.5C25.8785 3.5 27 4.62145 27 6V9C27 9.09726 26.9133 9.25357 26.6992 9.3584L26.5996 9.39941C25.5232 9.77205 24.75 10.7968 24.75 12C24.75 13.2031 25.5233 14.2269 26.5996 14.5996V14.6006C26.8867 14.7011 27 14.8889 27 15V18C27 19.3785 25.8785 20.5 24.5 20.5H3.5C2.12145 20.5 1 19.3785 1 18V15C1 14.8889 1.11334 14.7011 1.40039 14.6006L1.39941 14.5996C2.47617 14.2271 3.25 13.2034 3.25 12C3.25 10.7965 2.47633 9.7718 1.39941 9.39941H1.40039C1.11334 9.29893 1 9.11113 1 9V6C1 4.62145 2.12145 3.5 3.5 3.5Z"
                stroke="white"
              />
              <path
                d="M17.5 9L11.5 15M11.5 9L17.5 15"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </CustomYellow>
          <Typography fontSize={24} fontWeight={600}>
            900
          </Typography>
          <Typography fontSize={16} fontWeight={500}>
            Total Unredeemed <br />
            Tickets
          </Typography>
        </CustomContainer>
        <CustomContainer color="#0092FF">
          <CustomBlue>
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.58 7.60745L1 7.45445C2.849 2.70445 8.158 0.0004462 13.333 1.34445C18.846 2.77745 22.121 8.26245 20.647 13.5944C19.428 18.0054 15.343 20.9314 10.847 21.0004"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11 21.0005C5.5 21.0005 1 16.0005 1 10.0005M12.604 8.72251C12.252 8.35251 11.391 7.48551 10.029 8.10251C8.668 8.71751 8.452 10.6985 10.511 10.9095C11.441 11.0045 12.048 10.7995 12.604 11.3795C13.16 11.9615 13.263 13.5775 11.843 14.0135C10.423 14.4495 9.502 13.7295 9.255 13.5045M10.908 7.02051V7.81051M10.908 14.1475V15.0205"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </CustomBlue>
          <Typography fontSize={24} fontWeight={600}>
            120
          </Typography>
          <Typography fontSize={16} fontWeight={500}>
            Total Number of <br />
            Transactions
          </Typography>
        </CustomContainer>
        <CustomContainer color="#EA5455">
          <CustomRed>
            <svg
              width="28"
              height="24"
              viewBox="0 0 28 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 3.5H24.5C25.8785 3.5 27 4.62145 27 6V9C27 9.09726 26.9133 9.25357 26.6992 9.3584L26.5996 9.39941C25.5232 9.77205 24.75 10.7968 24.75 12C24.75 13.2031 25.5233 14.2269 26.5996 14.5996V14.6006C26.8867 14.7011 27 14.8889 27 15V18C27 19.3785 25.8785 20.5 24.5 20.5H3.5C2.12145 20.5 1 19.3785 1 18V15C1 14.8889 1.11334 14.7011 1.40039 14.6006L1.39941 14.5996C2.47617 14.2271 3.25 13.2034 3.25 12C3.25 10.7965 2.47633 9.7718 1.39941 9.39941H1.40039C1.11334 9.29893 1 9.11113 1 9V6C1 4.62145 2.12145 3.5 3.5 3.5Z"
                stroke="white"
              />
              <path
                d="M14.0986 7.78613L15.043 10.0146L15.1611 10.293L15.4619 10.3184L17.875 10.5225L16.041 12.1123L15.8135 12.3096L15.8818 12.6035L16.4307 14.9609L14.3574 13.707L14.0996 13.5508L13.8408 13.707L11.7656 14.957L12.3154 12.5986L12.3838 12.3047L12.1562 12.1074L10.3232 10.5176L12.7363 10.3135L13.0361 10.2881L13.1543 10.0107L14.0986 7.78613Z"
                stroke="white"
              />
            </svg>
          </CustomRed>
          <Typography fontSize={24} fontWeight={600}>
            3,500
          </Typography>
          <Typography fontSize={16} fontWeight={500}>
            Total Number of Tickets <br />
            Sold per Ticket Type
          </Typography>
        </CustomContainer>
        <CustomContainer color="#0092FF">
          <CustomBlue>
            <svg
              width="10"
              height="20"
              viewBox="0 0 10 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 15.345C1.65391 16.1483 2.552 16.7163 3.558 16.963C5.832 17.552 8.07 16.517 8.557 14.653C9.044 12.787 7.284 10.753 5.011 10.163C2.738 9.573 0.977 7.54 1.464 5.675C1.951 3.81 4.188 2.776 6.462 3.365C7.444 3.601 8.332 4.158 9 4.957M5.121 17.128V19M5.121 1V3.2"
                stroke="white"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </CustomBlue>
          <Typography fontSize={24} fontWeight={600}>
            $150
          </Typography>
          <Typography fontSize={16} fontWeight={500}>
            Total Amount <br />
            in $
          </Typography>
        </CustomContainer>
        <CustomContainer color="#FDD70E">
          <CustomYellow>
            <svg
              width="18"
              height="21"
              viewBox="0 0 18 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.0996 4.5H5.09961M7.09961 8.5H5.09961M1.09961 17.146V6.554C1.09961 3.7 1.09961 2.274 1.97861 1.387C2.85661 0.5 4.27161 0.5 7.09961 0.5H11.0996C13.9276 0.5 15.3426 0.5 16.2206 1.387C17.0996 2.273 17.0996 3.7 17.0996 6.554V17.146C17.0996 18.657 17.0996 19.413 16.6376 19.711C15.8826 20.197 14.7156 19.177 14.1286 18.807C13.6436 18.501 13.4016 18.349 13.1316 18.34C12.8416 18.33 12.5946 18.477 12.0706 18.807L10.1596 20.012C9.64361 20.337 9.38661 20.5 9.09961 20.5C8.81261 20.5 8.55561 20.337 8.03961 20.012L6.12961 18.807C5.64361 18.501 5.40161 18.349 5.13261 18.34C4.84161 18.33 4.59461 18.477 4.07061 18.807C3.48361 19.177 2.31661 20.197 1.56061 19.711C1.09961 19.413 1.09961 18.658 1.09961 17.146Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.5996 8.375C10.7716 8.375 10.0996 8.963 10.0996 9.688C10.0996 10.412 10.7716 11 11.5996 11C12.4276 11 13.0996 11.588 13.0996 12.313C13.0996 13.037 12.4276 13.625 11.5996 13.625M11.5996 8.375C12.2526 8.375 12.8086 8.74 13.0146 9.25M11.5996 8.375V7.5M11.5996 13.625C10.9466 13.625 10.3906 13.26 10.1846 12.75M11.5996 13.625V14.5"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </CustomYellow>
          <Typography fontSize={24} fontWeight={600}>
            $125
          </Typography>
          <Typography fontSize={16} fontWeight={500}>
            Total Fees <br />
            Amount
          </Typography>
        </CustomContainer>
        <CustomContainer color="#0092FF">
          <CustomBlue>
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 22.4529C11.105 22.4529 10.455 21.7099 9.88198 21.0529C9.60102 20.6747 9.25041 20.3536 8.84898 20.1069C8.36997 19.9862 7.87201 19.9601 7.38298 20.0299C6.9675 20.1242 6.53671 20.1289 6.11926 20.0437C5.70182 19.9586 5.30731 19.7854 4.96198 19.5359C4.71245 19.1906 4.53934 18.7961 4.45416 18.3786C4.36898 17.9612 4.37369 17.5304 4.46798 17.1149C4.53785 16.6259 4.51169 16.1279 4.39098 15.6489C4.1443 15.2475 3.82321 14.8969 3.44498 14.6159C2.78998 14.0429 2.04498 13.3939 2.04498 12.4979C2.04498 11.6019 2.78798 10.9529 3.44498 10.3799C3.82331 10.0987 4.1444 9.74771 4.39098 9.34592C4.51156 8.86723 4.53772 8.36962 4.46798 7.88092C4.37369 7.46544 4.36898 7.03464 4.45416 6.6172C4.53934 6.19976 4.71245 5.80525 4.96198 5.45992C5.30754 5.21038 5.70201 5.03681 6.11946 4.95063C6.5369 4.86446 6.96785 4.86762 7.38398 4.95992C7.87223 5.03194 8.36983 5.00817 8.84898 4.88992C9.25032 4.64353 9.60093 4.32279 9.88198 3.94492C10.455 3.28992 11.105 2.54492 12 2.54492C12.895 2.54492 13.545 3.28692 14.118 3.94492C14.3992 4.32325 14.7502 4.64434 15.152 4.89092C15.6304 5.01137 16.1276 5.03752 16.616 4.96792C17.0321 4.87562 17.4631 4.87246 17.8805 4.95863C18.298 5.04481 18.6924 5.21838 19.038 5.46792C19.2887 5.8129 19.4629 6.20736 19.5492 6.625C19.6354 7.04264 19.6316 7.47387 19.538 7.88992C19.4684 8.37829 19.4945 8.87555 19.615 9.35392C19.8616 9.75571 20.1827 10.1067 20.561 10.3879C21.216 10.9609 21.961 11.6109 21.961 12.5059C21.961 13.4009 21.218 14.0509 20.561 14.6239C20.1831 14.905 19.8624 15.2556 19.616 15.6569C19.4954 16.1356 19.4692 16.6332 19.539 17.1219C19.6326 17.538 19.6364 17.9692 19.5502 18.3868C19.4639 18.8045 19.2897 19.1989 19.039 19.5439C18.6931 19.7923 18.2986 19.9647 17.8813 20.0499C17.4641 20.135 17.0335 20.1309 16.618 20.0379C16.1293 19.9682 15.6317 19.9943 15.153 20.1149C14.7512 20.3615 14.4002 20.6826 14.119 21.0609C13.545 21.7099 12.9 22.4529 12 22.4529ZM8.09298 18.9999C8.48058 18.9868 8.86704 19.0489 9.23098 19.1829C9.7818 19.4772 10.2601 19.8905 10.631 20.3929C11.085 20.9129 11.555 21.4499 11.996 21.4499C12.437 21.4499 12.907 20.9129 13.362 20.3929C13.7329 19.8905 14.2112 19.4772 14.762 19.1829C15.3791 18.9929 16.0305 18.941 16.67 19.0309C17.342 19.0719 18.036 19.1159 18.323 18.8309C18.61 18.5459 18.568 17.8489 18.523 17.1779C18.4329 16.5381 18.4848 15.8864 18.675 15.2689C18.9689 14.7182 19.3819 14.2399 19.884 13.8689C20.404 13.4149 20.941 12.9449 20.941 12.5039C20.941 12.0629 20.404 11.5929 19.884 11.1389C19.3819 10.7679 18.9689 10.2896 18.675 9.73892C18.4849 9.12178 18.433 8.47037 18.523 7.83092C18.564 7.15992 18.607 6.46592 18.323 6.17792C18.039 5.88992 17.341 5.93192 16.67 5.97792C16.0305 6.06788 15.3791 6.01598 14.762 5.82592C14.2113 5.53197 13.733 5.11896 13.362 4.61692C12.908 4.09692 12.438 3.55992 11.997 3.55992C11.556 3.55992 11.086 4.09692 10.632 4.61692C10.261 5.11896 9.7827 5.53197 9.23198 5.82592C8.61453 6.01613 7.96276 6.06803 7.32298 5.97792C6.65298 5.93692 5.95898 5.89392 5.66998 6.17792C5.38098 6.46192 5.42598 7.15892 5.46998 7.82992C5.55746 8.46704 5.50421 9.1156 5.31398 9.72992C5.01975 10.2807 4.60638 10.759 4.10398 11.1299C3.58398 11.5839 3.04698 12.0549 3.04698 12.4949C3.04698 12.9349 3.58398 13.4059 4.10398 13.8609C4.60638 14.2318 5.01975 14.7101 5.31398 15.2609C5.50434 15.8787 5.55624 16.5308 5.46598 17.1709C5.42498 17.8429 5.38198 18.5369 5.66598 18.8239C5.94998 19.1109 6.64598 19.0689 7.31898 19.0239C7.57798 19.0189 7.83798 18.9999 8.09298 18.9999Z"
                fill="white"
              />
              <path
                d="M14.5 14.0001C14.4984 14.53 14.2872 15.0378 13.9125 15.4125C13.5377 15.7873 13.0299 15.9985 12.5 16.0001V17.0101C12.4974 17.1409 12.4436 17.2656 12.3501 17.3572C12.2566 17.4488 12.1309 17.5001 12 17.5001C11.9348 17.5014 11.87 17.4897 11.8094 17.4657C11.7488 17.4416 11.6936 17.4058 11.647 17.3601C11.6005 17.3145 11.5635 17.26 11.5382 17.1999C11.513 17.1398 11.5 17.0753 11.5 17.0101V16.0001H10.25C10.1174 16.0001 9.99021 15.9474 9.89645 15.8536C9.80268 15.7598 9.75 15.6327 9.75 15.5001C9.75 15.3675 9.80268 15.2403 9.89645 15.1465C9.99021 15.0527 10.1174 15.0001 10.25 15.0001H12.5C12.7652 15.0001 13.0196 14.8947 13.2071 14.7072C13.3946 14.5196 13.5 14.2653 13.5 14.0001C13.5 13.7348 13.3946 13.4805 13.2071 13.293C13.0196 13.1054 12.7652 13.0001 12.5 13.0001H11.5C10.9696 13.0001 10.4609 12.7893 10.0858 12.4143C9.71071 12.0392 9.5 11.5305 9.5 11.0001C9.5 10.4696 9.71071 9.96092 10.0858 9.58585C10.4609 9.21078 10.9696 9.00006 11.5 9.00006V7.95306C11.5026 7.89031 11.5176 7.82869 11.5442 7.77181C11.5708 7.71492 11.6085 7.66391 11.655 7.62174C11.7016 7.57957 11.756 7.54709 11.8153 7.5262C11.8745 7.50531 11.9373 7.49642 12 7.50006C12.1257 7.49458 12.2485 7.53866 12.342 7.62282C12.4355 7.70698 12.4923 7.82449 12.5 7.95006V9.00006H13.75C13.8826 9.00006 14.0098 9.05274 14.1036 9.14651C14.1973 9.24028 14.25 9.36745 14.25 9.50006C14.2474 9.63187 14.1939 9.75756 14.1007 9.85078C14.0075 9.944 13.8818 9.9975 13.75 10.0001H11.5C11.2348 10.0001 10.9804 10.1054 10.7929 10.293C10.6054 10.4805 10.5 10.7348 10.5 11.0001C10.5 11.2653 10.6054 11.5196 10.7929 11.7072C10.9804 11.8947 11.2348 12.0001 11.5 12.0001H12.5C13.0304 12.0001 13.5391 12.2108 13.9142 12.5858C14.2893 12.9609 14.5 13.4696 14.5 14.0001Z"
                fill="white"
              />
            </svg>
          </CustomBlue>
          <Typography fontSize={24} fontWeight={600}>
            $120
          </Typography>
          <Typography fontSize={16} fontWeight={500}>
            Total Sales <br />
            Net Amount
          </Typography>
        </CustomContainer>
        <CustomContainer color="#EA5455">
          <CustomRed>
            <svg
              width="22"
              height="21"
              viewBox="0 0 22 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.5 3.5C16.8978 3.5 17.2794 3.65804 17.5607 3.93934C17.842 4.22064 18 4.60218 18 5C18 5.39782 17.842 5.77936 17.5607 6.06066C17.2794 6.34196 16.8978 6.5 16.5 6.5C16.1022 6.5 15.7206 6.34196 15.4393 6.06066C15.158 5.77936 15 5.39782 15 5C15 4.60218 15.158 4.22064 15.4393 3.93934C15.7206 3.65804 16.1022 3.5 16.5 3.5Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1.77389 9.64447C0.770887 10.7645 0.749887 12.4545 1.66989 13.6445C3.4569 15.9643 5.5361 18.0435 7.85589 19.8305C9.04589 20.7505 10.7359 20.7295 11.8559 19.7265C14.8835 17.0183 17.7284 14.1126 20.3719 11.0285C20.6388 10.7217 20.8031 10.3392 20.8419 9.93447C21.0059 8.13847 21.3449 2.96447 19.9399 1.56047C18.5349 0.156468 13.3619 0.494468 11.5659 0.659468C11.1611 0.698246 10.7786 0.862576 10.4719 1.12947C7.38776 3.77268 4.48207 6.61724 1.77389 9.64447Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.7888 10.8673C12.8108 10.4653 12.9228 9.73233 12.3128 9.17433M12.3128 9.17433C12.0801 8.97209 11.809 8.81872 11.5158 8.72333C10.2588 8.28033 8.71581 9.76233 9.80781 11.1193C10.3948 11.8493 10.8478 12.0733 10.8038 12.9013C10.7738 13.4833 10.2018 14.0923 9.44781 14.3243C8.79281 14.5263 8.06981 14.2593 7.61281 13.7483C7.05381 13.1243 7.11081 12.5363 7.10581 12.2803M12.3128 9.17433L13.0008 8.48633M7.66081 13.8263L7.00781 14.4793"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </CustomRed>
          <Typography fontSize={24} fontWeight={600}>
            $120
          </Typography>
          <Typography fontSize={16} fontWeight={500}>
            Total Sales <br />
            Gross
          </Typography>
        </CustomContainer>
      </Grid>
    </Stack>
  );
};
